import axios from "axios"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { getId, getToken, usePermissions } from "../../user/User"
import BasicTableComponent, { NumberRangeColumnFilter, SelectColumnFilter, TagColumnFilter } from "../../components/basic.table"
import { toast } from "react-toastify"
import { getStatusOptions } from "../../data/Data"

const ClientList = () => {
    const navigate = useNavigate()

    const { permissions } = usePermissions(getId())
    useEffect(() => {
        if(permissions.client !== undefined && !permissions.client) {
            toast.error("You don't have permission to view clients!")
            navigate("/")
        }
    }, [permissions])

    const handleCreate = async e => {
        e.preventDefault(),
        navigate("/client/create")
    }

    const handleBoard = async e => {
        e.preventDefault(),
        navigate("/client/board")
    }

    const columns =  [{
        Header: "Edit",
        UrlPart: "client"
    }, {
        Header: "Delete",
        UrlPart: "client/delete"
    }, {
        Header: "Id",
        accessor: "id",
//        Filter: NumberRangeColumnFilter,
//        filter: 'between'
    }, {
        Header: "Company name",
        accessor: "company_name"
    }, {
        Header: "Sector",
        accessor: "sector_name",
        Filter: SelectColumnFilter,
        filter: 'equals'
    }, {
        Header: "Salesperson",
        accessor: "sales_person_name",
        Filter: SelectColumnFilter,
        filter: 'includes'
    }, {
        Header: "Status",
        accessor: (row, _) => {
            return getStatusOptions().filter(option => option.value == row.status)[0].label
        },
        Filter: SelectColumnFilter,
        filter: 'equals'
    }, {
        Header: "Status updated",
        accessor: (row, _) => {
            return new Date(row.status_updated).toLocaleString(undefined, {
                dateStyle: "medium",
                timeStyle: "short",
            });
        }
    }, {
        Header: "Initial price in €",
        accessor: "initial_price",
        Filter: NumberRangeColumnFilter,
        filter: 'between'
    }, {
        Header: "Initial payment",
        accessor: (row, _) => {
            return new Date(row.initial_payment_date).toLocaleString(undefined, {
                dateStyle: "medium",
                timeStyle: undefined,
            });
        }
    }, {
        Header: "Service agreement start", 
        accessor: (row, _) => {
            return new Date(row.service_agreement_start).toLocaleString(undefined, {
                dateStyle: "medium",
                timeStyle: undefined,
            });
        }
    }, {
        Header: "Service agreement end",
        accessor: (row, _) => {
            return new Date(row.service_agreement_end).toLocaleString(undefined, {
                dateStyle: "medium",
                timeStyle: undefined,
            });
        }
    }, {
        Header: "Monthly price in €",
        accessor: "monthly_price",
        Filter: NumberRangeColumnFilter,
        filter: 'between'
    }, {
        Header: "Built website",
        accessor: (row, _) => {
            return row.built_website ? "Yes" : "No"
        },
        Filter: SelectColumnFilter,
        filter: 'equals'
    }, {
        Header: "Tags",
        accessor: (row, _) => {
            return row.tag_names == null ? "" : row.tag_names.map(String).join(", ")
        },
        Filter: TagColumnFilter,
    }, {
//        Header: "Contact person",
//        accessor: "contact_person"
//    }, {
//        Header: "Email address",
//        accessor: "email_address"
//    }, {
//        Header: "Phone number",
//        accessor: "phone_number"
//    }, {
        Header: "Created",
        accessor: (row, _) => {
            return new Date(row.created).toLocaleString(undefined, {
                dateStyle: "medium",
                timeStyle: "short",
            });
        }
    }]

    const [clients, setClients] = useState([])
    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + "/api/clients", {
            headers: {
                "Authorization": "Bearer " + getToken()
            }
        })
        .then(res => {
            if(res.data === null || res.data === "") {
                return
            }
            setClients(res.data)
        }).catch(_ => {
            toast.error("Unable to load clients!")
        })
    }, [])

    return (
        <div>
            <button className="btn btn-primary" onClick={handleCreate}>Create client</button>
            &nbsp;
            <button className="btn btn-primary" onClick={handleBoard}>Open client board</button>
            <br /><br />

            <BasicTableComponent columns={columns} data={clients} />
        </div>
    )
}

export default ClientList
